import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Shield, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

// MediaKshetra Brand Colors
const GOLD = '#D4A84B';
const GOLD_MUTED = '#B8975F';
const DARK_BG = '#0E0E0E';
const CARD_BG = '#141414';
const MUTED = '#9CA3AF';

export const LogoutPage = () => {
  const handleReturn = () => {
    window.location.href = 'https://mediakshetra.com';
  };

  const handleReLogin = () => {
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: DARK_BG }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-lg text-center"
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-10">
          <div className="w-10 h-10 rounded flex items-center justify-center" style={{ backgroundColor: GOLD }}>
            <BarChart3 className="w-6 h-6 text-black" />
          </div>
          <span className="text-xl font-semibold tracking-tight text-white">MediaKshetra</span>
          <span className="text-xs tracking-widest uppercase" style={{ color: GOLD_MUTED }}>GIOS</span>
        </div>

        {/* Message Card */}
        <div className="rounded-lg p-10" style={{ backgroundColor: CARD_BG, border: `1px solid ${GOLD}1A` }}>
          {/* Security Badge */}
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 rounded-full flex items-center justify-center" 
                 style={{ backgroundColor: `${GOLD}15` }}>
              <Shield className="w-7 h-7" style={{ color: GOLD }} />
            </div>
          </div>

          <h1 className="text-2xl font-light text-white mb-4 tracking-tight">
            Session Ended Securely
          </h1>
          
          <p className="text-sm leading-relaxed mb-8" style={{ color: MUTED }}>
            You have securely exited your Growth Infrastructure environment.<br />
            MediaKshetra GIOS™ maintains session-level security and workspace isolation.
          </p>

          <div className="space-y-3">
            <Button
              onClick={handleReturn}
              data-testid="return-mediakshetra-button"
              className="w-full h-11 text-sm font-medium tracking-wide transition-all duration-300"
              style={{ backgroundColor: GOLD, color: '#000' }}
            >
              Return to MediaKshetra <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
            
            <Button
              onClick={handleReLogin}
              data-testid="relogin-button"
              variant="outline"
              className="w-full h-11 text-sm font-medium tracking-wide"
              style={{ borderColor: `${GOLD}40`, color: MUTED }}
            >
              Re-enter GIOS
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8">
          <p className="text-[10px] tracking-wider uppercase" style={{ color: `${MUTED}50` }}>
            MediaKshetra Confidential Environment
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default LogoutPage;
